import { render, staticRenderFns } from "./KETHubgeraete.vue?vue&type=template&id=456831b3&"
import script from "./KETHubgeraete.vue?vue&type=script&lang=js&"
export * from "./KETHubgeraete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports